import axios from 'axios';
import { authService } from './authService';
import { adminAuthService } from './adminAuthService';

// Create API instance with base configuration
const api = axios.create({
  baseURL: 'https://api.scriptlinkrx.com',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

const safeNavigate = (path: string) => {
  window.history.pushState({}, '', path);
  window.location.reload();
};

// Request interceptor for adding auth tokens and logging
api.interceptors.request.use(
  async (config) => {
    // First check if this is an admin endpoint
    const isAdminEndpoint =
      config.url?.includes('/admin') || config.url?.includes('admin-user');

    if (isAdminEndpoint) {
      // Try to get admin token from localStorage
      if (typeof window !== 'undefined') {
        const adminToken = localStorage.getItem('adminToken');
        if (adminToken) {
          // Format: Add Bearer prefix if not already present
          config.headers.Authorization = adminToken.startsWith('Bearer ')
            ? adminToken
            : `Bearer ${adminToken}`;
        } else {
          console.warn(
            '⚠️ No admin token found for admin endpoint:',
            config.url
          );
        }
      }
    } else {
      // Regular user authentication flow
      // Try to get token from localStorage
      let token = null;

      if (typeof window !== 'undefined') {
        token = localStorage.getItem('token');
      }

      // Note: NextAuth session removed - only using localStorage for tokens

      // Set Authorization header if we have a token
      if (token) {
        // Format: Add Bearer prefix if not already present
        config.headers.Authorization = token.startsWith('Bearer ')
          ? token
          : `Bearer ${token}`;
      } else {
        console.warn('No token found for request to:', config.url);
      }
    }

    // Log request info

    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for logging and handling errors
api.interceptors.response.use(
  (response) => {
    // Log successful response (abbreviated if large)

    return response;
  },
  (error) => {
    // Handle and log error response
    if (error.response) {
      // Error from server


      // If unauthorized, handle token issues
      if (error.response.status === 401) {
        console.error('401 Unauthorized - Token may be invalid or expired');

        // Check if this was an admin endpoint
        const isAdminEndpoint =
          error.config?.url?.includes('/admin') ||
          error.config?.url?.includes('admin-user');

        if (isAdminEndpoint) {
          // Remove invalid admin token
          if (typeof window !== 'undefined') {
            localStorage.removeItem('adminToken');

            // Logout admin and redirect to login page
            if (adminAuthService.isAdminLoggedIn()) {
              adminAuthService.logout();

              // Use setTimeout to avoid state updates during render
              setTimeout(() => {
                safeNavigate('/login/admin');
              }, 100);
            }
          }
        } else {
          // Handle business user authentication
          if (typeof window !== 'undefined') {
            // Remove invalid user token
            localStorage.removeItem('token');
            localStorage.removeItem('businessAToken');
            localStorage.removeItem('businessBToken');

            // Logout user and redirect to login page
            if (
              authService.isBusinessALoggedIn() ||
              authService.isBusinessBLoggedIn()
            ) {
              authService.logout();

              // Use setTimeout to avoid state updates during render
              setTimeout(() => {
                safeNavigate('/login/business-a');
              }, 100);
            }
          }
        }
      }
    } else if (error.request) {
      // No response received
    } else {
      // Error setting up request
    }
    return Promise.reject(error);
  }
);

export default api;
